import { withFullStoryExclude } from "../../../utils/fullStoryHelper";

const columns = [
    {
        Header: "glStatusOverviewVRSideLines_Nr",
        Accessor: "Nr",
        Filterable: false,
    },
    {
        Header: "glStatusOverviewVRSideLines_reconStatus",
        Accessor: "Status",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_companyCode",
        Accessor: "Company Code",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_invoiceNumber",
        Accessor: "Invoice Number",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_transactionDate",
        Accessor: "Transaction Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValueExclVAT",
        Accessor: "Total Value excl VAT",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValueExclVAT2",
        Accessor: "Total Value excl VAT 2",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValueExclVAT3",
        Accessor: "Total Value excl VAT 3",
        Filterable: true,
        IsCurrency: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValueExclVAT4",
        Accessor: "Total Value excl VAT 4",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValueExclVAT5",
        Accessor: "Total Value excl VAT 5",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValue",
        Accessor: "Total Value",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValue2",
        Accessor: "Total Value 2",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValue3",
        Accessor: "Total Value 3",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValue4",
        Accessor: "Total Value 4",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_totalValue5",
        Accessor: "Total Value 5",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_currency",
        Accessor: "Currency Key",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_currency2",
        Accessor: "Currency Key 2",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_currency3",
        Accessor: "Currency Key 3",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_currency4",
        Accessor: "Currency Key 4",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_currency5",
        Accessor: "Currency Key 5",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewVRSideLines_vatAmount",
        Accessor: "VAT Amount",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_vatAmount2",
        Accessor: "VAT Amount 2",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_vatAmount3",
        Accessor: "VAT Amount 3",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_vatAmount4",
        Accessor: "VAT Amount 4",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewVRSideLines_vatAmount5",
        Accessor: "VAT Amount 5",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
];

export default columns;
